import gql from "graphql-tag";
export const GROUPS_OF_TENANT = gql`query ListGroupsOfTenant($tenantUuid: ID!) {
  groupsOfTenant: listGroupsOfTenant(tenant_uuid: $tenantUuid) {
    uuid
    name
    tenant_uuid
  }
}`;